import { StringHelpers } from "./string-helpers";

export class MaskHelpers {
  static getValue(mask: string): string {
    if (mask) {
      return mask.replace(/\D/g, '');
    }
    return '';
  }

  static toMask(source: string, mask: string): string {
    source = MaskHelpers.getValue(source);

    let sourceIndex = 0;
    let specialCharCount = 0

    for (let index = 0; index < mask.length; index++) {
      if (sourceIndex < source.length) {
        if (mask.charAt(index) == 'd') {
          mask = StringHelpers.replaceAt(mask, index, source.charAt(sourceIndex));
          sourceIndex++;
        } else {
          specialCharCount++;
        }
      } else {
        break;
      }
    }

    return mask.substr(0, source.length + specialCharCount);
  }
}
